import React from 'react';
import logo from '../../assets/Humd Logo 300px-01.jpg';

const styles = {
  nav: {
    position: 'sticky', top: 0, zIndex: 100,
    background: 'rgba(255,255,255,0.97)',
    backdropFilter: 'blur(10px)',
    borderBottom: '1px solid #D1D5DB',
    height: 58,
    display: 'flex', alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0 40px',
  },
  brand: { display: 'flex', alignItems: 'center', gap: 12 },
  logoImg: {
    height: 50,
    width: 'auto',
    objectFit: 'contain',
  },
  divider: { width: 1, height: 18, background: '#D1D5DB' },
  doc: { fontSize: 12, fontWeight: 500, color: 'var(--gray)' },
  right: { display: 'flex', alignItems: 'center', gap: 16 },
  date: { fontSize: 12, color: 'var(--gray)' },
  cta: {
    background: 'var(--g2)', color: '#fff',
    border: 'none', borderRadius: 5,
    padding: '7px 16px', fontSize: 12, fontWeight: 600,
    cursor: 'pointer', textDecoration: 'none',
    transition: 'background 0.15s',
  },
};

export default function Navbar() {
  return (
    <nav className="r25-navbar" style={styles.nav}>
      <div style={styles.brand}>
        <img src={logo} alt="HUMD" className="r25-nav-logo" style={styles.logoImg} />
        <div className="r25-nav-divider" style={styles.divider} />
        <span className="r25-nav-doc" style={styles.doc}>2025 Investor Update</span>
      </div>
      <div className="r25-nav-right" style={styles.right}>
        <span style={styles.date}>March 2026 · Confidential</span>
        <a href="mailto:teamhumd@humd.co" style={styles.cta}>Get in Touch</a>
      </div>
    </nav>
  );
}
